import React from 'react';
import { FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import './infocontactComponent.scss';

const InfoContactComponent = () => {
  return (
    <div className="infocontact">
      <div className="infocontact__card">
        <div className="infocontact__icon-container">
          <FaPhone className="infocontact__icon" />
        </div>
        <div className="infocontact__info">
          <h3 className="infocontact__heading">Teléfono</h3>
          <p className="infocontact__text">+34 640 35 80 55</p>
        </div>
      </div>

      <div className="infocontact__card">
        <div className="infocontact__icon-container">
          <FaWhatsapp className="infocontact__icon" />
        </div>
        <div className="infocontact__info">
          <h3 className="infocontact__heading">WhatsApp</h3>
          <p className="infocontact__text">+34 640 35 80 55</p>
        </div>
      </div>

      <div className="infocontact__card">
        <div className="infocontact__icon-container">
          <FaEnvelope className="infocontact__icon" />
        </div>
        <div className="infocontact__info">
          <h3 className="infocontact__heading">Email</h3>
          <p className="infocontact__text">arodriguez@wonderaly.com</p>
        </div>
      </div>
    </div>
  );
};

export default InfoContactComponent;
